module.exports = __webpack_public_path__ + "static/media/nachos.90f4d34a.jpg";